



























































































































































































































import * as firebase from 'firebase';
import 'firebase/firestore';
import { Component, Watch,  Prop, Vue } from 'vue-property-decorator';
import recipesDB from '../server/init';
import commentsDB from '../server/init';
import recipeCategories from '../server/init';
import categoryRecipes from '../server/init';
import AddRecipe from '../components/shared/AddRecipe.vue';
import EditRecipe from '../components/shared/EditRecipe.vue';
import AddComment from '../components/shared/AddComment.vue';
import EditComment from '../components/shared/EditComment.vue';
import { TrinityRingsSpinner } from 'epic-spinners';
import { firebaseAuth } from '../server/init';
import usersDB from '../server/init';


@Component({
  components: {
    AddRecipe,
    EditRecipe,
    AddComment,
    EditComment,
    TrinityRingsSpinner,
  },
})
export default class Recipes extends Vue {
  private recipeId: string;
  private recipeCategories: Array<any> = [];
  private activeCategory: string = 'desserts';
  private activeRecipes: Array<any> = [];
  // TODO: Hook up authentication
  private user: any | null;
  private userAdmin: boolean = false;
  private superAdmin: boolean = false;
  private author: boolean = true;
  private addRecipe: boolean = false;
  private addComment: boolean = false;
  private editRecipeSheet: boolean = false;
  private editCommentSheet: boolean = false;
  private showBottomSheet: boolean = false;
  private activeRecipe: string;
  private reviewAuthor: string;
  private reviewDate: string;
  private activeReviewTitle: string;
  private activeReviewBody: string;
  private recipeTitle: string;
  private recipeReviews: number = 0;
  private screenSize: number = screen.width;
  setSticky: boolean = false;
  lastScrollPosition: number = 0;
  // TODO Remove set sticky and last scroll and use shared drop down component

  private data() {
    return {
      showBottomSheet: false,
      emptyIcon: 'mdi-beaker-outline',
      fullIcon: 'mdi-beaker',
      // halfIcon: 'mdi-beaker-half-full',
      halfIncrements: false,
      hover: true,
      length: 5,
      size: 24,
      dense: true,
      color: '#0b633e',
      bgColor: '#8c6831',
      catLoading: true,
      recipesLoading: true,
      readonly: false,
      accordionArrow: 'mdi-menu-down',
      recipeReviews: [],
      reviewId: null,
      recipeId: null,
    };
  }

  private switchCategory(category: string) {
    this.activeCategory = category;
    this.activeRecipes = [];
    this.updateRecipes();
  }

  private updateRecipes() {
    this.activeRecipes = [];
    categoryRecipes.collection('recipes').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const recipe = doc.data();
        if ( recipe.category === this.activeCategory) {
          this.recipeId = doc.id;
          this.activeRecipes.push(recipe);
        }
      });
    });
  }

  private setActiveCategory(activeCategory: string) {
    if (activeCategory === this.activeCategory) {
      return true;
    } else {
      return false;
    }
  }

  private showRecipeSheet() {
    this.editRecipeSheet = false;
    this.showBottomSheet = true;
    this.addRecipe = true;
    this.addComment = false;
    this.editCommentSheet = false;
  }

  private deleteRecipe(recipeTitle: string, recipeCategory: string) {
    const confirmation = confirm(`Are you sure you want to delete ${recipeTitle} from the ${recipeCategory} recipes?`);
    if (confirmation) {

      categoryRecipes.collection('recipes').doc(this.$data.recipeId).delete()
      .then(() => {
        this.activeRecipes = this.activeRecipes.filter((recipe) => {

        return recipe.title !== recipeTitle;
        });
      });
    }
  }


  private reload() {
    window.location.reload();
  }

  private editRecipe(cat: string, catId: string) {
    this.activeRecipe = cat;
    this.editRecipeSheet = true;
    this.addRecipe = false;
    this.showBottomSheet = true;
    this.editCommentSheet = false;
    this.addComment = false;
  }

  private addReview(recipe: string) {
    this.recipeTitle = recipe;
    this.addComment = true;
    this.editRecipeSheet = false;
    this.addRecipe = false;
    this.editCommentSheet = false;
    this.showBottomSheet = true;
  }

  private deleteComment(recipe_index: number, title: string, index: number) {
    const confirmation = confirm(`Are you sure you want to delete this comment?`);
    if (confirmation) {
      this.activeRecipes[recipe_index].reviews.splice(index, 1);
      recipesDB.collection('recipes').doc(this.$data.recipeId).update({
        reviews: this.activeRecipes[recipe_index].reviews,
      });
    }
  }

  private editComment(recipeId: string, reviewTitle: string, reviewBody: string, reviewAuthor: string, reviewDate: string) {
    this.activeReviewTitle = reviewTitle;
    this.activeReviewBody = reviewBody;
    this.activeRecipe = recipeId;
    this.reviewAuthor = reviewAuthor;
    this.reviewDate = reviewDate;
    this.showBottomSheet = true;
    this.editCommentSheet = true;
  }



  private getReviewsById(id: number) {
    return recipesDB.collection('recipes').doc().get();
  }

  private voteCommentUp(rank: number, title: string, index: number) {
    const reviews = this.$data.recipeReviews;
    reviews.forEach((review: any) => {
      if (title === review.title) {
        review.rank = review.rank + 1;
        this.sortReviews();
      }
      recipesDB.collection('recipes').doc(this.$data.recipeId).update({
          reviews: this.$data.recipeReviews,
        });
    });
  }

  private voteCommentDown(rank: number, title: string, index: number) {
    const reviews = this.$data.recipeReviews;
    reviews.forEach((review: any) => {
      if (title === review.title && review.rank > 0 ) {
        review.rank = review.rank - 1;
        this.sortReviews();
      }
      recipesDB.collection('recipes').doc(this.$data.recipeId).update({
          reviews: this.$data.recipeReviews,
        });
    });
  }

  private sortReviews(...reviews: any) {
    console.log('reviews array', this.$data.recipeReviews);
    // console.log(reviews.sort((a,b) => {return a.reviews.reviews.rank - b.reviews.reviews.rank}));
  }

  handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.body.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 40) {
        return;
      }
      this.setSticky = currentScrollPosition > this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    }

  private created() {
    recipeCategories.collection('recipeCategories').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const category = doc.data();
        this.recipeCategories.push(category);
        this.$data.catLoading = false;
      });
    });

    categoryRecipes.collection('recipes').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const recipe = doc.data();
        if ( recipe.category === this.activeCategory) {
          const recipes = [];
          recipes.push(recipe);
          this.$data.recipesLoading = false;
          this.$data.recipeReviews = recipe.reviews;
        }
      });
    });

    firebaseAuth.onAuthStateChanged((user) => {
        user = firebaseAuth.currentUser;
        if (user) {
          usersDB.collection('users').where('user_id', '==', user.uid).get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.user = doc.data();

              if (this.user.superAdmin) {
                this.superAdmin = true;
              }
            });
          });
        }
      });
    this.switchCategory(this.activeCategory);
  }

  private mounted() {
    document.body.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }

  @Watch('screenSize')
  private onchange(val: number, oldVal: number) {
    this.screenSize = val;
  }
}
